import { Fragment } from 'react';
import { useSearchableMenu } from './SearchableMenuContext';
export function SearchableMenuBody(props) {
    const { children } = props;
    const { items } = useSearchableMenu();
    const renderProps = {
        items,
    };
    const renderItems = () => {
        if (typeof children === 'function') {
            return <Fragment>{children(renderProps)}</Fragment>;
        }
        return children;
    };
    return renderItems();
}
